/**
 * Localization messages for ActivateRuleModal component
 */
import sharedMessages from '../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../utils/localization';

const componentMessages = {
  // Modal title
  'Save and Activate Rule': 'ruleRecs.activateRuleModal.title',

  // Modal description
  'Please provide the details below to save and activate the rule':
    'ruleRecs.activateRuleModal.description',

  // Form labels
  'Rule Name': 'ruleRecs.activateRuleModal.form.ruleNameLabel',

  // Form placeholders
  'Give this rule a unique name':
    'ruleRecs.activateRuleModal.form.ruleNamePlaceholder',
  'Provide a brief description for your rule':
    'ruleRecs.activateRuleModal.form.descriptionPlaceholder',

  // Advanced Options
  'Create matching Role':
    'ruleRecs.activateRuleModal.advancedOptions.createMatchingRoleLabel',
  'Birthright Access':
    'ruleRecs.activateRuleModal.advancedOptions.birthrightAccessLabel',
  'Mark this Technical Rule as a Birthright Rule':
    'ruleRecs.activateRuleModal.advancedOptions.birthrightAccessTooltip',
  "Remove access when user doesn't satisfy this rule":
    'ruleRecs.activateRuleModal.advancedOptions.removeAccessLabel',
  'Remove access assigned through the Birthright Rule if the rule conditions are no longer met':
    'ruleRecs.activateRuleModal.advancedOptions.removeAccessTooltip',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type ActivateRuleModalMessage = keyof typeof invertedMessages;

export default invertedMessages;
